/** Browser-ready URLs bypass stored-file preparation. */
export function isStoredMediaPath(src: string): boolean {
  return src !== '' && !src.startsWith('/') && !/^(?:https?:|blob:|data:|\/\/)/iu.test(src)
}

/** Includes nested prompts, choices, answer media, explanations and page covers. */
export function storedMediaPaths(blocks: unknown): string[] {
  const paths = new Set<string>()
  const add = (src: unknown) => { if (typeof src === 'string' && isStoredMediaPath(src)) paths.add(src) }
  const visit = (value: unknown) => {
    if (typeof value !== 'object' || value === null) return
    if (Array.isArray(value)) { for (const child of value) visit(child); return }
    const record = value as Record<string, unknown>
    add(record.src)
    if (record.type === 'pageMeta') { add(record.image); add(record.icon) }
    for (const child of Object.values(record)) visit(child)
  }
  visit(blocks)
  return [...paths].toSorted()
}
